import { User } from "oidc-client-ts";
import { EslavonApiResponse } from "shared/models/apiResponses/eslavonResponse";
import { CustomerOverview } from "shared/models/customerOverviewModel";

export const refreshLinkedCustomerSession = async (
    customerId: string,
    signinSilent: () => Promise<User | null>,
    loadCustomers: () => Promise<EslavonApiResponse<CustomerOverview[]>>,
): Promise<CustomerOverview> => {
    const refreshedUser = await signinSilent();
    const claim = refreshedUser?.profile["eslavon.customerid"];
    const customerIds = Array.isArray(claim) ? claim : claim ? [claim] : [];

    if (!customerIds.some(value => value.toString().toLowerCase() === customerId.toLowerCase())) {
        throw new Error("CUSTOMER_CLAIM_NOT_REFRESHED");
    }

    const customersResponse = await loadCustomers();
    const customer = customersResponse.result?.find(
        item => item.id.toLowerCase() === customerId.toLowerCase());
    if (!customer) {
        throw new Error("LINKED_CUSTOMER_NOT_RELOADED");
    }

    return customer;
};
